/**
 * Utility functions for account-related logic
 */

/**
 * Checks if an account type is considered an asset (positive balance increases net worth)
 * @param {string} type - The account type (checking, savings, credit, cash)
 * @returns {boolean}
 */
export const isAsset = (type) => {
    return ['checking', 'savings', 'cash'].includes(type);
};

/**
 * Gets the standardized label for an account type
 * @param {string} type - The account type
 * @returns {string}
 */
export const getTypeLabel = (type) => {
    const labels = {
        checking: 'Bancos',
        savings: 'Ahorros',
        credit: 'Tarjeta de Crédito',
        cash: 'Efectivo'
    };
    return labels[type] || 'Otro';
};

/**
 * Calculates the net impact of an account balance on total wealth
 * @param {string} type 
 * @param {number|string} balance 
 * @returns {number}
 */
export const getBalanceImpact = (type, balance) => {
    const numBalance = Number(balance || 0);
    return isAsset(type) ? numBalance : -numBalance;
};
